exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---3hh53 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .component---3hh53 .attempt---2MIM4 {\n    font-weight: bold; }\n  .component---3hh53 .attempt---2MIM4 .percent---2Brh1 {\n      font-size: 12px; }\n  .component---3hh53 .null-attempt---3v4M0 {\n    color: #999b9d; }\n  .component---3hh53 .avg---2hsdB {\n    padding: 0 8px;\n    background: #cfd2d4;\n    border-radius: 10px;\n    font-size: 12px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3hh53",
	"attempt": "attempt---2MIM4",
	"percent": "percent---2Brh1",
	"null-attempt": "null-attempt---3v4M0",
	"avg": "avg---2hsdB"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/participation-result/participation-result.scss
// module id = Vx94
// module chunks = 1